import React from "react"
import {Access} from "../../gd/const/access"

import {ProjectAccess, ProjectAccessDescriptionDictionary, ProjectAccessLabelDictionary} from "../../gd/const/project"
import FieldsFactory from "../../fields3/fields-factory"
import {FieldType} from "../../fields3/field-type"
import FieldInlineEditable from "../../fields3/render/inline-editable"

type Props = {
    className?          : string

    value?              : number
    accessLevels?       : number[]

    showDisabledLevels? : boolean

    onSelect?           : {(access: Access):void}
}

export default function SelectAccess(props:Props) {

    const onSelect = (newValue: Access) => {
        if (props.onSelect) props.onSelect(newValue);
    }

    let customAccessOptions = [
        {
            value           : ProjectAccess.FULL,
            label           : 'Full',
            description     : ProjectAccessDescriptionDictionary[ProjectAccess.FULL],
            disabled        : !props.accessLevels?.includes(ProjectAccess.FULL),
        },
        {
            value           : ProjectAccess.STANDARD,
            label           : ProjectAccessLabelDictionary[ProjectAccess.STANDARD],
            description     : ProjectAccessDescriptionDictionary[ProjectAccess.STANDARD],
            disabled        : !props.accessLevels?.includes(ProjectAccess.STANDARD),
        },
        {
            value           : ProjectAccess.LIMITED,
            label           : ProjectAccessLabelDictionary[ProjectAccess.LIMITED],
            description     : ProjectAccessDescriptionDictionary[ProjectAccess.LIMITED],
            disabled        : !props.accessLevels?.includes(ProjectAccess.LIMITED),
        },

        {
            value           : ProjectAccess.CLIENT,
            label           : ProjectAccessLabelDictionary[ProjectAccess.CLIENT],
            description     : ProjectAccessDescriptionDictionary[ProjectAccess.CLIENT],
            notSelectable   : true,
            disabled        : !props.accessLevels?.includes(ProjectAccess.CLIENT),
        },
        {
            value           : ProjectAccess.READ_ONLY,
            label           : ProjectAccessLabelDictionary[ProjectAccess.READ_ONLY],
            description     : ProjectAccessDescriptionDictionary[ProjectAccess.READ_ONLY],
            disabled        : !props.accessLevels?.includes(ProjectAccess.READ_ONLY),
        },
    ]

    if (!props.showDisabledLevels) {
        customAccessOptions = _.filter(customAccessOptions, option => !option.disabled)
    }

    const field = FieldsFactory.get({
        fieldId : 'access',
        type    : FieldType.PROJECT_ACCESS,
        options : customAccessOptions
    })

    return <FieldInlineEditable className   = {Classes('select-access', props.className)}
                                field       = {field}
                                model       = {{
                                    access: props.value,
                                }}
                                onChange    = {onSelect} />
}

SelectAccess.defaultProps = {
    value       : Access.STANDARD,
    accessLevels: [
        Access.READ_ONLY,
        Access.CLIENT,
        Access.LIMITED,
        Access.STANDARD,
        Access.FULL
    ]
}